export default __webpack_public_path__ + "CircularPro-Medium.cb1e9614.otf";